var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$$FormData.slicer_type === 'line')?_c('div',{staticClass:"diyImage-slicer line",style:({
    padding: ("0 " + (_vm.$$FormData.slicer_padding) + "px"),
  })},[_c('div',{staticClass:"assist-slicer__hr",style:({ borderTop: ("1px " + (_vm.$$FormData.slicer_style) + " " + (_vm.$$FormData.slicer_color)) })})]):_c('div',{staticClass:"diyImage-slicer",style:({})},[_c('div',{staticClass:"swiper-pc2"},_vm._l((_vm.$$FormData.diy_num),function(n,index){return _c('div',{key:index,staticClass:"div-z1",style:({
        width: _vm.$$FormData.diy_image_width + 'px',
        height: _vm.$$FormData.diy_image_height + 'px',
      })},[_c('img',{style:({
          width: _vm.$$FormData.diy_image_width + 'px',
          height: _vm.$$FormData.diy_image_height + 'px',
        }),attrs:{"src":_vm.formatSrc(n).src}})])}),0)])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3e0fac38","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Decors/DiyImageSlicer/DiyImageSlicerPreview.vue
// module id = null
// module chunks = 